import { render, staticRenderFns } from "./MainCategoriesCard.vue?vue&type=template&id=b664bef4&scoped=true"
import script from "./MainCategoriesCard.vue?vue&type=script&lang=js"
export * from "./MainCategoriesCard.vue?vue&type=script&lang=js"
import style0 from "./MainCategoriesCard.vue?vue&type=style&index=0&id=b664bef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b664bef4",
  null
  
)

export default component.exports